module.exports = __webpack_public_path__ + "static/img/05.b1d009dc.jpg";